// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class AtrioService {

  apiUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getAtrioInitialData(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `common/atrio/initial-data`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }

  getDbUsers(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requesttUrl = this.apiUrl + `db-users`;

    return this.http.get(requesttUrl, { headers })
      .pipe(
        map((res: Response) => res)
      );
  }
}
